export const DeviceButtonSet = {
  // FA204 / frank trap — DEVICE_LABELS used to be a bare module-scope const
  // read from inside `childProps` (a serialized factory); it read as
  // undefined once this component was frank.toJSON'd for platform delivery
  // (workspace d6ea1142, project_frank_drops_module_local_helpers). Kept in
  // `scope` so `el.scope.DEVICE_LABELS` resolves post-serialization too —
  // note `el.scope.previewSize` below is a SEPARATE, pre-existing use of the
  // same bag as ad-hoc runtime instance state (not a frank concern), so this
  // is additive, not a new pattern.
  scope: {
    DEVICE_LABELS: {
      custom: 'Custom size',
      mobileXS: 'Mobile preview',
      tabletS: 'Tablet portrait preview',
      tabletL: 'Tablet landscape preview',
      screenM: 'Small screen preview',
      screenL: 'Large screen preview',
      resizable: 'Resizable preview',
      canvas: 'Canvas view'
    }
  },
  extends: 'NavbarButtonSet',
  gap: 'A',
  childProps: (el, state) => {
    const isActive = el.scope.previewSize === state.key
    const isThreeDots = state.icon === 'threeDotsVertical' && 'threeDotsVertical'
    const isResize =
      state.icon === 'dimensionsAlt' && (isActive ? state.icon + ' colored outline' : state.icon)

    return {
      isActive,
      isThreeDots,
      theme: null,
      background: 'transparent.0',
      color: 'inactive',
      aria: { label: el.scope.DEVICE_LABELS[state.key] || state.key },
      icon: isResize || isThreeDots || isActive ? state.icon : state.icon + ' outline',

      '.isThreeDots': {
        order: -15
      },

      // Adaptive (was fixed 'gray4'/'gray10') — the house hover wash + full-
      // ink brighten, matching the weaker-than-`.isActive` step this set
      // already uses (isActive below is the stronger `secondary-highlight`
      // filled theme).
      ':hover': {
        background: 'hover',
        color: 'title'
      },

      '.isActive': {
        opacity: 1,
        theme: 'secondary-highlight'
      },

      onClick: (ev, el, s, ctx) => {
        const previewSize = s.key !== el.scope.previewSize ? s.key : 'unset'
        el.scope.previewSize = previewSize
        el.parent.update()
        ctx.utils.setCookie('previewSize', previewSize)
        el.syncCanvas()
      }
    }
  },
  childrenAs: 'state',
  children: () => [
    {
      key: 'custom',
      icon: 'threeDotsVertical'
    },
    {
      key: 'mobileXS',
      icon: 'deviceMobile'
    },
    {
      key: 'tabletS',
      icon: 'deviceTabletPortrait'
    },
    {
      key: 'tabletL',
      icon: 'deviceTabletLandscape'
    },
    {
      key: 'screenM',
      icon: 'deviceSmallScreen'
    },
    {
      key: 'screenL',
      icon: 'deviceBigScreen'
    },
    {
      key: 'resizable',
      icon: 'dimensionsAlt'
    },
    {
      key: 'canvas',
      icon: 'columns'
    }
  ]
}
